// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604200903/js/" + chunkId + "." + {"44":"14cd33c8","225":"af3af3cf","481":"b18fb13c","486":"6b3811aa","770":"1332d83d"}[chunkId] + ".0.15771426860030924.chunk.js";
};